const searchClient = algoliasearch(
    'YWW4OR0G1W',
    '76d9e776bb72aebad4d9d4ce0a754e5c'
);

const search = instantsearch({
  indexName: 'shopify_products', // your Algolia products index name
  searchClient,
});

search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox', // update this selector to match your search page
  }),

  instantsearch.widgets.hits({
    container: '#hits', // update this selector to match your search page
  })
]);

search.start();
